<template>
  <Modal v-model="modalVisible"
         :title="modalTitle"
         :hide-header-close="true"
         :static="staticModal"
         :size="size"
         @ok="confirmed"
         @hide="cancelled">
    <slot name="beforeMessage"></slot>
    <p class="text-break"
       v-html="sanitizedMessage"></p>
    <slot name="additionalInfo"></slot>
    <template #modal-footer="{ ok, hide }">
      <slot :ok="ok"
            :hide="hide"
            name="footer">
        <ButtonGroup :primary-button-text="tr('javascript.TX_DELETE')"
                     :secondary-button-text="tr('javascript.TX_ABORT')"
                     primary-button-icon-name="bin"
                     secondary-button-icon-name="cancel-circle"
                     @primary-button-click="ok"
                     @secondary-button-click="hide">
        </ButtonGroup>
      </slot>
    </template>
  </Modal>
</template>

<script>
  import purify from 'dompurify';
  import Modal from './Modal.vue';
  import ButtonGroup from './ButtonGroup.vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  export default {
    name: 'DeleteModal',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Modal,
      ButtonGroup,
    },
    mixins: [translator],
    props: {
      message: {
        type: String,
        required: true,
      },
      title: String,
      staticModal: {
        type: Boolean,
        default: true,
      },
      size: {
        type: String,
        default: BootstrapVariant.SMALL,
      },
    },
    data() {
      return {
        modalVisible: false,
      };
    },
    computed: {
      modalTitle() {
        return this.title === undefined ? this.tr('javascript.TX_DELETE') : this.title;
      },
      sanitizedMessage() {
        return purify.sanitize(this.message);
      },
    },
    expose: ['confirm'],
    methods: {
      confirm() {
        this.modalVisible = true;
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      confirmed() {
        this.confirmDeletion(true);
      },
      cancelled() {
        this.confirmDeletion(false);
      },
      confirmDeletion(resolveValue) {
        if (this.resolve !== null) {
          this.resolve(resolveValue);
        }
        this.resolve = null;
      },
    },
  };
</script>
